export function changeLanguage(payload) {
  return {
    type: 'CHANGE_LANGUAGE',
    payload
  };
}
